<template>
  <footer v-if="footer" class="footer" :style="footerStyle">
    <div class="container">
      <FooterTop />
      <div class="footer-nav">
        <SbFooterItems :blok="footer.story.content" />
      </div>
      <FooterBottom />
    </div>
  </footer>
</template>

<script lang="ts" setup>
interface Props {
  footerColor: string | undefined
}
const { footerColor = '#fff' } = defineProps<Props>()

const storyblokApiInstance = useStoryblokApi()
const mainStore = useMainStore()
const { footer } = storeToRefs(mainStore)
const { locale } = useI18n()

const config = useRuntimeConfig()

const { data } = await useAsyncData(
  `footer-${locale.value}`,
  async () =>
    await storyblokApiInstance.get(`cdn/stories/global/footer-new`, {
      language: locale.value,
      version: config.public.storyblokApiVersion as 'draft' | 'published',
    }),
)
footer.value = data.value?.data

const footerStyle = computed(() => {
  return {
    'background-color': footerColor,
  }
})
</script>

<style lang="scss" scoped>
.footer {
  @include paragraph-xs;

  padding: 80px 0;
}

.footer-nav {
  width: 100%;
  padding: 48px 0 40px;
}
</style>
